import { useRef, useEffect, useState } from 'react';

/**
 * @param {*} effect 副作用函数
 */
export const useMounted = effect => {
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

/**
 * @param {*} effect 副作用函数
 * @param {*} deps 副作用依赖
 */
export const useUpdate = (effect, deps) => {
  // 标识是否是首次挂载
  const isMounted = useRef(false);
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

/**
 * useUnmounted
 * @returns boolean
 * whether the component is unmounted
 */
export const useUnmount = effect => {
  useEffect(
    () => () => {
      effect();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};

// 更新state的值，并且执行回调
export const useOnChange = (initValue, callback) => {
  const [state, setState] = useState(initValue);
  const handleSetState = value => {
    setState(value);
    if (callback) callback(value);
  };
  return [state, handleSetState];
};
